import {Address} from '@practicegenius/domain/src/data/address';
import {PracticeOffice} from '@practicegenius/domain/src/data/practice';
import {InterestedPartyType} from './components/InterestedParty';

export enum IsMember {
  YES = 'yes',
  NO = 'no',
  NULL = 'null',
}

export type ColorScheme = Record<number, string>;
export type GoogleMapInstance = google.maps.Map;
export type GoogleMapMarker = google.maps.Marker;
export type GoogleGeocoder = google.maps.Geocoder;
export type GeocoderResult = google.maps.GeocoderResult;
export type GeocoderStatus = google.maps.GeocoderStatus;
export type GeocoderGeometry = google.maps.GeocoderGeometry;

export type InfoFieldValues = Record<
  | 'firstName'
  | 'lastName'
  | 'phone'
  | 'email'
  | 'childFirstName'
  | 'childLastName',
  string
> & {interestedParty: InterestedPartyType};

export type InfoFieldErrors = Partial<
  Record<keyof (InfoFieldValues & {isMember: IsMember}), string>
>;

export type FormConfirmationData = {
  title: string;
  body: string;
};

export type Practice = Omit<PracticeOffice, 'id'> & {
  // TODO: PracticeOffice declares "name", but that doesn't exist on Practice
  practice_id: number;
  email: string;
  formatted_address: string;
  logo2: string;
  phone: string;
  practice_name: string;
};

export type MapLocation = Address & {
  name: string;
  geometry?: GeocoderGeometry;
};

export enum Layout {
  public = 'public',
  private = 'private',
}
